/* eslint-disable class-methods-use-this */
import moment from 'moment';
import { serviceWrapper, serviceConfigs } from '@/services/configs';

export default new class ResourceManager {
  constructor() {
    const onlyEnglishPages = [
      '/login',
      '/register',
      '/forgot-password',
      '/reset-password',
    ];
    let currentLocale;
    if (onlyEnglishPages.includes(window.location.pathname)) {
      currentLocale = 'en-US';
    } else if (window.localStorage.getItem('locale')) {
      currentLocale = window.localStorage.getItem('locale');
    } else {
      currentLocale = 'en-US';
    }
    this.$htmlLang = currentLocale;
    this.resource = {
      CurrentLang: currentLocale,
      Packages: {
        'en-US': {
          VersionSign: null,
          List: {},
        },
        'tr-TR': {
          VersionSign: null,
          List: {},
        },
        'es-ES': {
          VersionSign: null,
          List: {},
        },
        'fr-FR': {
          VersionSign: null,
          List: {},
        },
        'de-DE': {
          VersionSign: null,
          List: {},
        },
      },
    };
  }

  Get() {
    const param = {};
    this.resource = this.CurrentResource;
    const current = this.resource.Packages[this.resource.CurrentLang];

    if (current && current.VersionSign) param.versionSign = current.VersionSign;
    return serviceWrapper(
      serviceConfigs.resource,
      serviceConfigs.resource.getListByLanguage,
      param, {
        withoutAuth: true,
      },
    ).then((res) => {
      const {
        body,
      } = res.data;
      let objResourcesList = {};
      body.forEach((el) => {
        const oneResourceObj = {
          [el.key]: el.value,
        };
        objResourcesList = { ...objResourcesList, ...oneResourceObj };
      });
      window.dejavuApp.$moment.locale('en');
      document.documentElement.lang = this.CurrentLang;

      localStorage.setItem(this.dateKey, moment());

      this.resource.Packages[this.resource.CurrentLang] = {
        List: objResourcesList,
      };
      localStorage.setItem(this.resourceKey, JSON.stringify(this.resource));
      return this.resource.Packages[this.resource.CurrentLang];
    });
  }

  get CurrentLang() {
    return this.CurrentResource.CurrentLang;
  }

  get CurrentResource() {
    return JSON.parse(localStorage.getItem(this.resourceKey)) || this.resource;
  }

  get dateKey() {
    return 'resourceUpdateDate';
  }

  get resourceKey() {
    return 'SystemResourceModel';
  }

  set CurrentLang(val) {
    this.resource.CurrentLang = val;
    localStorage.setItem(this.resourceKey, JSON.stringify(this.resource));
  }
}();
